import React, { useEffect, useState } from 'react';

import { startOfWeek, startOfMonth, endOfMonth, endOfWeek } from 'date-fns';

import Calendar from 'react-calendar';


import { Container, Header, Wrapper } from './styles';
import { CaretLeft, CaretRight } from 'phosphor-react';
import api from '../../services/api';
import { IschedulesProps } from '../../interfaces/Schedule';
import { useHistory } from 'react-router-dom';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const CardCalendar: React.FC = () => {
  const history = useHistory();
  
  const [value, onChange] = useState<Value>(new Date());

  const [startDate, setStartDate] = useState(startOfWeek(startOfMonth(new Date())));
  const [endDate, setEndDate] = useState(endOfWeek(endOfMonth(new Date())));

  const [events, setEvents] = useState<IschedulesProps[]>([]);

  const handlePrevMonth = () => {
    const date = value as Date;
    const newDate = new Date(date.setMonth(date.getMonth() - 1));
    onChange(newDate);
  };

  const handleNextMonth = () => {
    const date = value as Date;
    const newDate = new Date(date.setMonth(date.getMonth() + 1));
    onChange(newDate);
  };

  const isEventDate = (date: Date) => {
    return events.some(event => {
      const eventDate = new Date(event.start_date);
      return date.getDate() === eventDate.getDate() &&
        date.getMonth() === eventDate.getMonth() &&
        date.getFullYear() === eventDate.getFullYear();
    });
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(`/schedules`, {
          params: {
            from: startDate,
            to: endDate,
          }
        });

        console.log(response.data);
        setEvents(response.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [startDate, endDate]);

  return (
    <Wrapper>
      <Header>
        <div>
          <h2>
            Calendário
          </h2>
          <h5>
            {value?.toLocaleString('pt-BR', {
              month: 'long',
              year: 'numeric'
            }).replace(/^\w/, (c) => c.toUpperCase())}
          </h5>
        </div>

        <aside>
          <button onClick={handlePrevMonth}><CaretLeft size={18} /></button>
          <button onClick={handleNextMonth}><CaretRight size={18} /></button>
        </aside>
      </Header>
      <Container>
        <Calendar
          onChange={onChange}
          value={value}
          showNavigation={false}
          tileClassName={({ date }) => {
            const today = new Date();
            const isToday =
              date.getDate() === today.getDate() &&
              date.getMonth() === today.getMonth() &&
              date.getFullYear() === today.getFullYear();

            const hasEvent = isEventDate(date);

            if (isToday && hasEvent) {
              return 'event-date is-today';
            }
            if (hasEvent) {
              return 'event-date';
            }
            if (isToday) {
              return 'is-today';
            }
            return null;
          }}
          onClickDay={(value, event) => {
            console.log(value);
            if (isEventDate(value)) {
              console.log('Evento encontrado', events.find(event => new Date(event.start_date).getDate() === value.getDate()));
              const event = events.find(event => new Date(event.start_date).getDate() === value.getDate());
              history.push(`/calendario/?eventId=${event?.id}`);
            }
          }}
        />

      </Container>
    </Wrapper>
  );
};

export default CardCalendar;
